<template>
    <div><slot /></div>
</template>

<script>
import { mapGetters } from 'vuex'
import { IS_LOGGED_IN } from '../../vuex-store/types'

export default {
    computed: {
        ...mapGetters({
            isLoggedIn: IS_LOGGED_IN
        })
    },
    watch: {
        isLoggedIn(isLoggedIn) {
            if (isLoggedIn) {
                this.$router.push('/')
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/Layout.vue